import { useNavigate, useSearchParams } from 'react-router-dom';
import ScreenRecorder from '../components/ScreenRecorder';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const NewProcessCapture = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const linkProcess = searchParams.get('linkProcess');

  const handleComplete = (captureId) => {
    navigate(`/process-capture/${captureId}`);
  };

  return (
    <div className="space-y-6 animate-fade-in" data-testid="new-capture-page">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-slate-900 font-['Plus_Jakarta_Sans']">New Process Capture</h1>
          <p className="text-slate-500 text-sm">Record your screen to document a process step-by-step</p>
        </div>
      </div>
      <div className="max-w-2xl">
        <ScreenRecorder onComplete={handleComplete} defaultLinkedProcessId={linkProcess} />
      </div>
    </div>
  );
};

export default NewProcessCapture;
